import {constantsTypes} from '../reduxConstants'

export const setViewMode = (value)=>{
    return{
        type: constantsTypes.VIEW_MODE,
        value : value
    }
}